import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import withJobActions from './withJobActions';
import Icon from '../../../common/containers/icon';
import JobFlangeValveInspection from '../../../admin/jobs/jobFlangeValveInspection';
const JobFlangeValveInspectionResultsSubsection = props => {
  const {
    active,
    onJobChange,
    userID
  } = props;
  const {
    flangeValveInspection = [],
    id
  } = active;
  const handleChange = useCallback((index, name, value) => {
    onJobChange(`flangeValveInspection[${index}]/${name}`, value);
  }, [onJobChange]);
  const handleAdd = useCallback(() => {
    const newFlangeValveInspection = [...flangeValveInspection, {
      jobID: id,
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: userID,
      id: uuidV4().toUpperCase()
    }];
    onJobChange('flangeValveInspection', newFlangeValveInspection);
  }, [flangeValveInspection, id, onJobChange, userID]);
  const handleRemove = useCallback(index => {
    const newFlangeValveInspection = JSON.parse(JSON.stringify(flangeValveInspection));
    newFlangeValveInspection.splice(index, 1);
    onJobChange('flangeValveInspection', newFlangeValveInspection);
  }, [flangeValveInspection, onJobChange]);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Flange / Valve Inspection Results"), /*#__PURE__*/React.createElement("hr", null), flangeValveInspection.map((fvi, index) => /*#__PURE__*/React.createElement(JobFlangeValveInspection, {
    key: `flangeValveInspection-${fvi.id}`,
    flangeValveInspection: fvi,
    onChange: handleChange,
    onRemove: handleRemove,
    index: index
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 2,
      offset: 10
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "form-control t-jfvi-add",
    onClick: handleAdd
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " Add Results"))));
};
JobFlangeValveInspectionResultsSubsection.propTypes = {
  userID: PropTypes.string.isRequired,
  active: PropTypes.shape({
    flangeValveInspection: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string
  }).isRequired,
  onJobChange: PropTypes.func.isRequired
};
export { JobFlangeValveInspectionResultsSubsection as UncomposedJobFlangeValveInspectionResultsSubsection };
export default withJobActions(JobFlangeValveInspectionResultsSubsection);